import useAccountCreationFields from '../../../hooks/useFields/useAccountCreationFields';
import { createMultiStepFormContext } from '../../../providers/MultiStepForm.provider';

import type { NewAccountData } from '../types';

const AccountCreationContext = createMultiStepFormContext<NewAccountData>(useAccountCreationFields);

export default AccountCreationContext;
